import React, { useRef } from "react";
import { FaGreaterThanEqual, FaLessThanEqual } from "react-icons/fa";
import NoDataFound from "../../Extra/NoDataFound";
import DownloadExcel from "../../Extra/DownloadExcel";
import CMSWorkingHourPercent from "./CMSWorkingHourPercent";
import CMSCustomHours from "./CMSCustomHours";
import { sumArrayOfObjects } from "../../Utilitie";
const columnLabels = {
  wh_less_than_equals_4hr: "<= 4 hrs",
  wh_4_to_6_hr: "4–6 hrs",
  wh_6_to_8_hr: "6–8 hrs",
  wh_8_to_9_hr: "8–9 hrs",
  wh_9_to10_hr: "9–10 hrs",
  wh_10_to_11_hr: "10–11 hrs",
  wh_11_to_12_hr: "11–12 hrs",
  wh_12_to_14_hr: "12–14 hrs",
  wh_more_than_14hr: "14+ hrs",
};
const headObject = {
  "0-4": "wh_less_than_equals_4hr",
  "4-6": "wh_4_to_6_hr",
  "6-8": "wh_6_to_8_hr",
  "8-9": "wh_8_to_9_hr",
  "9-10": "wh_9_to10_hr",
  "10-11": "wh_10_to_11_hr",
  "11-12": "wh_11_to_12_hr",
  "12-14": "wh_12_to_14_hr",
  "+14": "wh_more_than_14hr",
};
function getMonthlyTotals(data) {
  const map = {};

  data.forEach((obj) => {
    const key = `${obj.cms_year}-${obj.cms_month}`;

    if (!map[key]) {
      map[key] = {
        cms_year: obj.cms_year,
        cms_month: obj.cms_month,
        wh_lobby: "TOTAL",
        wh_less_than_equals_4hr: 0,
        wh_4_to_6_hr: 0,
        wh_6_to_8_hr: 0,
        wh_8_to_10_hr: 0,
        wh_10_to_12_hr: 0,
        wh_12_to_14_hr: 0,
        wh_more_than_14hr: 0,
        wh_total: 0,
      };
    }

    map[key].wh_less_than_equals_4hr += Number(obj.wh_less_than_equals_4hr);
    map[key].wh_4_to_6_hr += Number(obj.wh_4_to_6_hr);
    map[key].wh_6_to_8_hr += Number(obj.wh_6_to_8_hr);

    map[key].wh_8_to_10_hr +=
      Number(obj.wh_8_to_9_hr) + Number(obj.wh_9_to10_hr);
    map[key].wh_10_to_12_hr +=
      Number(obj.wh_10_to_11_hr) + Number(obj.wh_11_to_12_hr);

    map[key].wh_12_to_14_hr += Number(obj.wh_12_to_14_hr);
    map[key].wh_more_than_14hr += Number(obj.wh_more_than_14hr);

    map[key].wh_total += Number(obj.wh_total);
  });

  return Object.values(map);
}

const CMSMonthWorkingHourTable = ({ data }) => {
  const tableRef = useRef();
  const tempData = data?.filter((o) => o.wh_lobby !== "TOTAL");
  const monthlyTotals = getMonthlyTotals(tempData || []);
  const monthWiseSum = sumArrayOfObjects(
    data,
    ["cms_month"],
    ["wh_lobby", "cms_year", "cms_month"],
    "group_by"
  );
  return (
    <div className="">
      {/* <div className="newUiBody">
        <div className=" bg-dark text-white ps-2 p-1 d-flex align-items-center justify-content-between ">
          <h5 className="">Crew Working Hour Month Wise</h5>
        </div>

        <div className="table-responsive  ">
          <div className="" style={{ maxHeight: "400px", overflow: "auto" }}>
            <table
              className="table newUiTable table-striped table-hover"
              ref={tableRef}
            >
              <thead className="sticky-top" style={{ zIndex: 1 }}>
                <tr className="table-dark">
                  <th>SNo</th>
                  <th>Month</th>
                  <th>
                    <FaLessThanEqual /> 4 hrs
                  </th>
                  <th>
                    4 <FaGreaterThanEqual /> to <FaLessThanEqual /> 6 hrs
                  </th>
                  <th>
                    6 <FaGreaterThanEqual /> to <FaLessThanEqual /> 8 hrs
                  </th>
                  <th>
                    8 <FaGreaterThanEqual /> to <FaLessThanEqual /> 10 hrs
                  </th>
                  <th>
                    10 <FaGreaterThanEqual /> to <FaLessThanEqual /> 12 hrs
                  </th>
                  <th>
                    12 <FaGreaterThanEqual /> to <FaLessThanEqual /> 14 hrs
                  </th>
                  <th>
                    14 <FaGreaterThanEqual /> hrs
                  </th>
                  <th>Total</th>
                </tr>
              </thead>

              <tbody>
                {monthWiseSum &&
                  monthWiseSum.map((obj, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{obj.group_by}</td>
                        <td>{obj.wh_less_than_equals_4hr}</td>
                        <td>{obj.wh_4_to_6_hr}</td>
                        <td>{obj.wh_6_to_8_hr}</td>
                        <td>{obj.wh_8_to_9_hr + obj.wh_9_to10_hr}</td>
                        <td>{obj.wh_10_to_11_hr + obj.wh_11_to_12_hr}</td>
                        <td>{obj.wh_12_to_14_hr}</td>
                        <td>{obj.wh_more_than_14hr}</td>
                        <td>{obj.wh_total}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>

        {data?.length === 0 ? (
          <NoDataFound />
        ) : (
          <DownloadExcel tableRef={tableRef} fileName={`Crew Working Hours`} />
        )}
      </div> */}

      <div className="row ">
        <CMSCustomHours
          data={monthWiseSum}
          columnLabels={columnLabels}
          headObject={headObject}
          otherKey={["cms_month"]}
        />
      </div>
      <div className="row ">
        <CMSWorkingHourPercent data={monthWiseSum} otherKey={["cms_month"]} />
      </div>
    </div>
  );
};

export default CMSMonthWorkingHourTable;
